export default function () {
  return {
    restrict: "A",
    link: function (scope, elem) {
      elem.on("submit", function () {        

        var firstError = elem.find('label.error:visible:first()');
        // var firstError = elem.find('input.error')[0];
        
        if (firstError) {
          firstError.focus();
        }

        try{
          if( firstError.parent().find('select').length > 0){
            
          }
        }catch(e){

        }

      });
    }
  };
}